import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandContentSummary } from '@nibtravel/shared/util/models';
import { ProductsApiEndpointService } from '@nibtravel/shared/util/url';
import { map } from 'rxjs/operators';

import { BrandContentMap } from './models';

@Injectable({ providedIn: 'root' })
export class UiContentDataService {
  constructor(
    private http: HttpClient,
    private endpointService: ProductsApiEndpointService
  ) {}

  loadBrandContent(brand: string) {
    const url = this.endpointService.getBrandConfigUrl(brand);
    return this.http
      .get<BrandContentSummary>(url)
      .pipe(map((data) => this.mapData(data)));
  }

  mapData(data: BrandContentSummary): BrandContentMap {
    return data.contentItems.reduce(
      (a, c) => ({ ...a, [c.type]: c.content }),
      {} as BrandContentMap
    );
  }
}
